<template>
  <div :id="id"></div>
</template>


<script>
import * as echarts from "echarts/core";
import { LineChart } from "echarts/charts";
import {
  TooltipComponent,
  GridComponent,
  LegendComponent,
} from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([
  LineChart,
  CanvasRenderer,
  TooltipComponent,
  GridComponent,
  LegendComponent,
]);
export default {
  props: {
    id: {
      type: String,
      default: "liquid-line-chart",
    },
    list: {
      type: Array,
      default: () => [],
    },
  },

  watch: {
    list() {
      this.renderChart();
    },
  },

  mounted() {
    var chartDom = document.getElementById(this.id);
    chartDom.style.height = "30vh";
    chartDom.style.width = "28vw";
    this.chart = echarts.init(chartDom);
    this.renderChart();
  },

  methods: {
    renderChart() {
      var option = {
        legend: {
          show: true,
          textStyle: {
              color: '#fff',
          },
        },

        xAxis: {
          type: "category",
          data: this.list.map((item) => item.ts),
          splitLine: {
            show: true,
          },
          axisLine: {
            show: true,
            textStyle: {
                color: '#fff',
            },
          },
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false,
          },
          axisLine: {
            show: true,
          },
          axisLabel: {
            textStyle: {
                color: '#fff',
            },
          },
        },

        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          textStyle: {
              color: '#fff',
          },
        },

        grid: {
          show: false,
          left: "10%",
          top: "10%",
          right: "0%",
          bottom: "15%",
        },

        series: [
          {
            name: "溶解氧",
            type: "line",
            smooth: true,
            data: this.list.map((item) => item.doxygen),
          },
          {
            name: "透明度",
            type: "line",
            smooth: true,
            data: this.list.map((item) => item.ss),
          },
          {
            name: "氧化还原电位",
            type: "line",
            smooth: true,
            data: this.list.map((item) => item.orp),
          },
          {
            name: "化学需氧量",
            type: "line",
            smooth: true,
            data: this.list.map((item) => item.cod),
          },
          {
            name: "酸碱度",
            type: "line",
            smooth: true,
            data: this.list.map((item) => item.ph),
          },
          {
            name: "氨氮",
            type: "line",
            smooth: true,
            data: this.list.map((item) => item.nh4n),
          },
        ],
      };

      option && this.chart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped></style>